import { useState } from 'preact/hooks';
import { LineItem } from '@pperform/pp-data-mappers';
import { usePTPConfigContext } from 'GlobalConfig.context';
import { CardWrapper, CardDescriptionWrapper } from './MobileCard.styles';
import { useFormatItemsCard } from '../../ItemCommons/CommonItem.hook';

import { CardThumbnail } from '../Thumbnail';
import { CardDetails } from '../Details';
import { CardActions } from '../Actions';

interface MobileCardProps {
  card: LineItem;
  showDetailButton: boolean;
}

export const MobileCard = ({
  card,
  showDetailButton,
}: MobileCardProps): JSX.Element => {
  const [isShowDetails, setIsShowDetails] = useState<boolean>(false);
  const PTPConfig = usePTPConfigContext();
  const lineItemConfig = PTPConfig?.lineItem;
  const isTileView = lineItemConfig.visualisationType === 'tile_view';

  const {
    productImageUrl,
    productName,
    productUrl,
    productDescription,
    productPrice,
    productQuantity,
    productReasonForReturn,
    productCustomReasonForReturn,
    additionalInformation,
    productID,
  } = useFormatItemsCard(card);

  return (
    <CardWrapper isTileView={isTileView}>
      <CardThumbnail
        isTileView={isTileView}
        productName={productName}
        productImageUrl={productImageUrl}
      />
      <CardDescriptionWrapper isTileView={isTileView}>
        <CardDetails
          isTileView={isTileView}
          isShowDetails={isShowDetails}
          productName={productName}
          productPrice={productPrice}
          productQuantity={productQuantity}
          productUrl={productUrl}
          productDescription={productDescription}
          productReasonForReturn={productReasonForReturn}
          productCustomReasonForReturn={productCustomReasonForReturn}
          additionalInformation={additionalInformation}
          productID={productID}
        />
        {showDetailButton && (
          <CardActions
            isShowDetails={isShowDetails}
            setIsShowDetails={setIsShowDetails}
            ariaLabel={productName}
          />
        )}
      </CardDescriptionWrapper>
    </CardWrapper>
  );
};
